interface Props {
    borderColor?: string;
}

const GameBattleAvatarPlaceholder = ({ borderColor }: Props) => {
    return (
        <div
            className="relative w-8 h-8 rounded-[28%] grid place-items-center bg-layer_2"
            style={{
                border: `1px dashed ${borderColor ?? 'rgba(70,224,138,0.55)'}`,
                boxShadow: borderColor ? undefined : '0 0 10px -3px rgba(70,224,138,0.45)',
            }}
        >
            <svg
                viewBox="0 0 24 24"
                className="w-3 h-3 stroke-current fill-none text-text_3 [stroke-width:2] [stroke-linecap:round]"
            >
                <path d="M12 5v14M5 12h14" />
            </svg>
        </div>
    );
};

export default GameBattleAvatarPlaceholder;
